export { RecentlyViewedModule } from './RecentlyViewedModule';
export { RECENTLY_VIEWED_LIMIT, selectRecentlyViewedListings } from './recentlyViewedModule.utils';
